export default __webpack_public_path__ + "static/media/minecraft@2x.284d471e.webp";